import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { money, productImage, productThumb } from "../lib/api";

export default function ProductCard({ product }) {
  const minPrice = product.tier_pricing?.[0]?.unit_price ?? product.base_price;
  return (
    <Link
      to={`/shop/product/${product.slug}`}
      className="group relative bg-white border border-slate-200 hover:border-kolt-orange transition-all duration-300 flex flex-col overflow-hidden"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative aspect-[4/3] bg-slate-50 overflow-hidden">
        <img
          src={productThumb(product.image_url, 600)}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
          loading="lazy"
        />
        <span
          className="absolute top-3 left-3 max-w-[55%] truncate font-mono text-[10px] tracking-[0.22em] uppercase font-bold bg-white/90 backdrop-blur text-kolt-slate px-2 py-1"
          data-testid={`product-cat-${product.slug}`}
        >
          {product.category}
        </span>
        {product.is_featured && (
          <span className="absolute top-3 right-3 font-mono text-[10px] tracking-[0.22em] uppercase font-bold bg-kolt-orange text-white px-2 py-1">
            Featured
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-slate-400 mb-2">
          SKU {product.sku_prefix}-{(product.product_id || "").slice(-5).toUpperCase()}
        </div>
        <h3 className="font-display font-bold text-lg text-kolt-slate-dark leading-tight mb-2 group-hover:text-kolt-orange transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-slate-600 leading-relaxed line-clamp-2 mb-4 flex-1">
          {product.short_description}
        </p>
        <div className="border-t border-slate-100 pt-4 flex items-end justify-between">
          <div>
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-slate-400 font-bold">
              From
            </div>
            <div className="font-display font-black text-2xl text-kolt-slate-dark leading-none">
              {money(minPrice)}
              <span className="text-xs text-slate-500 font-semibold ml-1">/ unit</span>
            </div>
          </div>
          <span className="inline-flex items-center gap-1 font-mono text-[11px] tracking-[0.2em] uppercase font-bold text-kolt-slate group-hover:text-kolt-orange transition-colors">
            Configure
            <ArrowUpRight className="w-4 h-4 group-hover:rotate-12 transition-transform" />
          </span>
        </div>
      </div>
    </Link>
  );
}
